var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7229 53.614C18.1211 53.2157 18.6687 52.9834 19.2495 52.9834H71.9179C72.8804 52.9834 73.3616 54.145 72.6813 54.8253L62.277 65.2296C61.8788 65.6278 61.3312 65.8601 60.7504 65.8601H8.08194C7.1195 65.8601 6.63828 64.6986 7.31863 64.0182L17.7229 53.614Z",
    fill: "#F2DB1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7229 14.7692C18.1377 14.371 18.6853 14.1387 19.2495 14.1387H71.9179C72.8804 14.1387 73.3616 15.3002 72.6813 15.9806L62.277 26.3848C61.8788 26.7831 61.3312 27.0154 60.7504 27.0154H8.08194C7.1195 27.0154 6.63828 25.8538 7.31863 25.1735L17.7229 14.7692Z",
    fill: "#F2DB1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.277 34.0671C61.8788 33.6688 61.3312 33.4365 60.7504 33.4365H8.08194C7.1195 33.4365 6.63828 34.5981 7.31863 35.2784L17.7229 45.6827C18.1211 46.0809 18.6687 46.3132 19.2495 46.3132H71.9179C72.8804 46.3132 73.3616 45.1517 72.6813 44.4713L62.277 34.0671Z",
    fill: "#F2DB1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.491710fb7304a3fe9e999b0b1de8dcae.svg";
export { ForwardRef as ReactComponent };